import Vuex from 'vuex'
import { state } from '@/store/state'
import store from '@/store/modules/store'
import outletPrice from '@/store/modules/outletprice'
import global from '@/store/modules/global'
import item from '@/store/modules/item'
import menuItem from '@/store/modules/menuitem'
import menuItemLimit from '@/store/modules/menuitemlimit'
import menuGroup from '@/store/modules/menugroup'
import menuPrice from '@/store/modules/menuprice'
import menuGroupLimit from '@/store/modules/menugrouplimit'
import modifierItem from '@/store/modules/modifieritem'
import menuGroupSchedule from '@/store/modules/menuGroupSchedule'
import saleMenuSchedule from '@/store/modules/salemenuschedule'
import storeOpenSchedule from '@/store/modules/storeopenschedule'
import modifierPrice from '@/store/modules/modifierprice'
import storeDeliverySchedule from '@/store/modules/storedeliveryschedule'
import storeGeofence from '@/store/modules/storegeofence'
import orderReport from '@/store/modules/orderreport'
import commonUtils from '@/store/modules/commonutils'
import pageLoading from '@/store/modules/pageloading'
import mutations from '@/store/mutations'
import actions from '@/store/actions'
import downloadOrders from '@/store/modules/downloadOrders'
import feeCalculationSetting from '@/store/modules/feeCalculationSetting'
import deliverySetting from '@/store/modules/deliverySetting'
import billListOrder from '@/store/modules/billListOrder'
import login from '@/store/modules/login'
import menuUpload from '@/store/modules/menuUpload'
import menuvariant from '@/store/modules/menuvariant'
import merchantConfig from '@/store/modules/merchantConfig'
import waitingData from '@/store/modules/waitingData'
import customerUpload from '@/store/modules/customerUpload'
import review from '@/store/modules/review'
import merchantStaff from '@/store/modules/merchantStaff'
import messageGroup from '@/store/modules/messageGroup'

import Vue from 'vue'

Vue.use(Vuex)

export default new Vuex.Store({
  state,
  mutations,
  actions,
  modules: {
    store,
    outletPrice,
    global,
    item,
    menuGroup,
    menuItem,
    menuPrice,
    menuItemLimit,
    menuGroupLimit,
    modifierItem,
    modifierPrice,
    menuGroupSchedule,
    saleMenuSchedule,
    storeDeliverySchedule,
    storeOpenSchedule,
    storeGeofence,
    orderReport,
    commonUtils,
    pageLoading,
    downloadOrders,
    feeCalculationSetting,
    deliverySetting,
    billListOrder,
    login,
    menuUpload,
    menuvariant,
    merchantConfig,
    waitingData,
    customerUpload,
    review,
    merchantStaff,
    messageGroup
  }
})
